import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessIcon from '@mui/icons-material/Business';
import './PortalSelection.scss';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect } from 'react';
import { getTenantFromUrl } from '../../utils/tenant';

function PortalSelection() {
  const navigate = useNavigate();
  const tenant = getTenantFromUrl();
  console.log('tenant PortalSelection', tenant);
  useEffect(() => {
    async function checkSession() {
      try {
        await fetchAuthSession();
      } catch {
        navigate('/login');
      }
    }

    checkSession(); // Only after login, just in case user manually visits /portal-selection
  }, []);

  // const handlePortalSelect = (role) => {
  //   if (tenant === 'redwoodseed') {
  //     if (role === 'redwoodseed-admins') {
  //       window.location.href = `${process.env.REACT_APP_REDWOODSEED_AUTH_HOSTNAME}/redirect?portal=admin&portal-switch=1`;
  //     } else if (role === 'enterprise-users') {
  //       window.location.href = `${process.env.REACT_APP_REDWOODSEED_AUTH_HOSTNAME}/redirect?portal=enterprise&portal-switch=1`;
  //     }
  //   } else {
  //     if (role === 'initio-admins') {
  //       window.location.href = `${process.env.REACT_APP_AUTH_HOSTNAME}/redirect?portal=admin&portal-switch=1`;
  //     } else if (role === 'enterprise-users') {
  //       window.location.href = `${process.env.REACT_APP_AUTH_HOSTNAME}/redirect?portal=enterprise&portal-switch=1`;
  //     }
  //   }
  // };
  const handlePortalSelect = (role) => {
    const isRedwood = tenant === 'redwoodseed';
  
    const rolePortalMap = {
      'redwoodseed-admins': 'admin',
      'initio-admins': 'admin',
      'enterprise-users': 'enterprise',
    };
  
    const portal = rolePortalMap[role];
    if (!portal) return;
  
    const baseUrl = isRedwood
      ? process.env.REACT_APP_REDWOODSEED_AUTH_HOSTNAME
      : process.env.REACT_APP_AUTH_HOSTNAME;
  
    window.location.href = `${baseUrl}/redirect?portal=${portal}&portal-switch=1`;
  };
  return (
    <main className="portal-selection">
      <div className="portal-content">
        <Typography variant="h4" className="portal-title">
          Choose Your Portal
        </Typography>
        <Typography variant="body1" className="portal-subtitle">
          You have access to multiple portals. Please select where you want to continue:
        </Typography>

        <div className="portal-options">
          <Button
            className="portal-option admin-option"
            onClick={() => handlePortalSelect(tenant === 'redwoodseed' ? 'redwoodseed-admins' : 'initio-admins')}
            role="button"
            tabIndex={0}
          >
            <div className="portal-icon">
              <AdminPanelSettingsIcon style={{ fontSize: '8rem' }} />
            </div>
            <Typography variant="h5">Admin 409A</Typography>
            <Typography variant="body2">
              Run valuations with ease, manage clients, run calculations, generate sandbox reports, and deliver insights seamlessly.
            </Typography>
          </Button>

          <Button
            className="portal-option enterprise-option"
            onClick={() => handlePortalSelect('enterprise-users')}
            role="button"
            tabIndex={0}
          >
            <div className="portal-icon">
              <BusinessIcon style={{ fontSize: '8rem' }} />
            </div>
            <Typography variant="h5">ASC 820</Typography>
            <Typography variant="body2">
              Manage investor firms, share pricing, CapIQ comps, run valuations and generate enterprise-grade reports with precision.
            </Typography>
          </Button>
        </div>
      </div>
    </main>
  );
}

export default PortalSelection; 